import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%'
});

export const hide = css({
  display: 'none'
});
